// extracted by css-extract-rspack-plugin
export default {"storage_message":"NjxOx","storageMessage":"NjxOx"};